import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './pdp-size-input-page_types.2';

export function getPdpSizeInputPage(variable: types.GetPdpSizeInputPageVariables, options?: GqlRequestOptions) {
  const query = 'query GetPdpSizeInputPage($size_category_id: ID) { pdp_size_input_page(size_category_id: $size_category_id) { size_category_list { id key name children { id key parent_id name image_url template_value { key name } } } } }';
  return gql_request<types.GetPdpSizeInputPage, types.GetPdpSizeInputPageVariables>('GetPdpSizeInputPage', query, variable, { use_consumer: true, ...options });
}

